import React, { useState } from 'react';
import { CardContent, Typography, Grid } from '@mui/material';
import ManagementPortfolio from './grave/ManagementPortfolio';
import useQueries from '../../../database/useQueries';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { mapFieldValues } from '../plagins/utility';
import GraveDocuments from '../plagins/documents/GraveDocuments';
import LoadingOverlay from '../pagesMains/LoadingOverlay';
import { format, parseISO } from 'date-fns';
import { AttachedDocuments } from './grave/accessoriesStyles';
import { TabContentColumnsPurchase } from './grave/TabContentColumnsPurchase';
import { useContext } from 'react';
import { GlobalContext } from '../../../App';
import { TabContentColumnsBurial } from './grave/TabContentColumnsBurial';
import TabContentColumnsHistory from './grave/TabContentColumnsHistory';
import { formatPriceIL } from '../plagins/data/commponentOptions';
import { createFetchDataServer } from '../../../database/fetchData';
import { DataContext } from '../pagesMains/GravesManagers/Graves';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useNavigate } from 'react-router-dom';

const ExternalLink = ({ text, data }) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(`/customer/${data.unicId}`, {
      state: {
        value: data
      }
    });
  };

  return (
    <div style={{ display: 'inline', alignItems: 'center' }}>
      <span>{text}</span>
      <button
        onClick={handleNavigate}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          marginRight: '8px',
          display: 'inline',
          alignItems: 'center',
          color: 'blue'
        }}
        aria-label="Navigate">
        <OpenInNewIcon style={{ fontSize: '26px' }} />
      </button>
    </div>
  );
};

function GraveDetail({ grave = {} }) {
  const { token, permission } = useContext(GlobalContext);

  // קבלת ערכים מהסטור
  const optionsFields = useSelector((state) => state.dataOptionsFieldsHe.data);
  const columnsPurchase = useSelector((state) => state.columnsPropertiesPurchases.data);
  const columnsBurial = useSelector((state) => state.columnsPropertiesBurials.data);

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);

  // טעינת היוזים לפונקציות עזר
  const { getEntityByAttr } = useQueries();

  const [loading, setLoading] = useState(true); // מצב טעינה

  // שמירה על מצב העמודות
  const [purchaseContent, setPurchaseContent] = useState(null);
  const [burialContent, setBurialContent] = useState(null);

  const [purchase, setPurchase] = useState(mapFieldValues([getEntityByAttr(context?.contextPurchases, 'graveId', grave?.unicId)], optionsFields)[0]);
  const [burial, setBurial] = useState(mapFieldValues([getEntityByAttr(context?.contextBurials, 'graveId', grave?.unicId)], optionsFields)[0]);
  useEffect(() => {
    context?.contextAreaGraves?.length > 0 && context?.contextGraves?.length > 0 && setLoading(false);
    setPurchase(mapFieldValues([getEntityByAttr(context?.contextPurchases, 'graveId', grave?.unicId)], optionsFields)[0]);
    setBurial(mapFieldValues([getEntityByAttr(context?.contextBurials, 'graveId', grave?.unicId)], optionsFields)[0]);
  }, [context]);

  const generateColumns = (data, columns) => {
    if (Object.keys(data).length !== 0) {
      return columns?.map((column) => {
        let value = data[column.field];
        if (column.field === 'clientFullNameHe') {
          const client = getEntityByAttr(context?.contextCustomers, 'unicId', data?.clientId);
          value = <ExternalLink data={client} text={value} />;
        }
        if (column.field === 'dateOpening' || column.field === 'PaymentEndDate' || column.field === 'reportingBL' || column.field === 'dateBurial') {
          try {
            const date = parseISO(value);
            value = format(date, 'dd/MM/yyyy');
          } catch (error) {
            value = ''; // ערך לא תקין, אפשר להחזיר ערך ריק או מה שמתאים לך
          }
        }
        if (column.field === 'numOfPayments') {
          if (!value) {
            value = 1;
          }
        }
        if (column.field === 'spacious') {
          return null;
        }
        if (column.field === 'price') {
          value = formatPriceIL(value);
        }
        return {
          field: column.field,
          title: column.headerName,
          value
        };
      });
    }
  };
  const handleUpdatePurchaseContent = (updatedData) => {
    const tempPurchase = { ...purchase, ...updatedData };

    setPurchase(tempPurchase);

    const updatedColumns = generateColumns(tempPurchase, columnsPurchase);

    setPurchaseContent(updatedColumns);
  };

  useEffect(() => {
    const tempPurchaseContent = handleUpdatePurchaseContent(purchase, columnsPurchase);
    if (JSON.stringify(purchaseContent) !== JSON.stringify(tempPurchaseContent)) {
      setPurchaseContent(tempPurchaseContent);
    }
  }, [purchase]);

  useEffect(() => {
    // const generateColumns = (data, columns) => {
    //   if (Object.keys(data).length !== 0) {
    //     return columns?.map((column) => {
    //       let value = data[column.field];
    //       if (column.field === 'clientFullNameHe') {
    //         const client = getEntityByAttr(context?.contextCustomers, 'unicId', data?.clientId);
    //         value = <ExternalLink data={client} text={value} />
    //       }
    //       if (column.field === 'dateOpening' || column.field === 'PaymentEndDate' || column.field === 'reportingBL' || column.field === 'dateBurial') {
    //         try {
    //           const date = parseISO(value);
    //           value = format(date, 'dd/MM/yyyy');
    //         } catch (error) {
    //           value = ''; // ערך לא תקין, אפשר להחזיר ערך ריק או מה שמתאים לך
    //         }
    //       }
    //       if (column.field === 'numOfPayments') {
    //         if (data[column.field] === 0 || data[column.field] === null || data[column.field] === undefined || data[column.field] === '') {
    //           value = 1;
    //         }
    //       }
    //       if (column.field === 'spacious') {
    //         return null;
    //       }
    //       if (column.field === 'price') {
    //         value = formatPriceIL(data[column.field]);
    //       }
    //       return {
    //         field: column.field,
    //         title: column.headerName,
    //         value
    //       };
    //     });
    //   }
    // };

    setPurchaseContent(purchase ? generateColumns(purchase, columnsPurchase) : []);
    setBurialContent(burial ? generateColumns(burial, columnsBurial) : []);
  }, [purchase, burial]);

  const myPermissionsPurchase = [1, 3];
  const myPermissionsBurial = [1, 3];
  const myPermissionsDocuments = [1, 3];
  const myPermissionsAttachedDocuments = [1];


  const [refreshKey, setRefreshKey] = useState(0);

  const tabsData = [
    {
      label: 'רכישה',
      content: <TabContentColumnsPurchase
      key={refreshKey}
      grave={grave} purchase={purchase} burial={burial} columns={purchaseContent} onUpdate={handleUpdatePurchaseContent} />,
      disabled: permission === 0 ? false : !myPermissionsPurchase.includes(permission)
    },
    {
      label: 'קבורה',
      content: <TabContentColumnsBurial grave={grave} purchase={purchase} burial={burial} columns={burialContent} />,
      disabled: permission === 0 ? false : !myPermissionsBurial.includes(permission)
    },
    {
      label: 'מסמכים',
      content: <GraveDocuments grave={grave} purchase={purchase} purchaseContent={purchaseContent} burialContent={burialContent} />,
      disabled: permission === 0 ? false : !myPermissionsDocuments.includes(permission)
    },
    {
      label: 'צרופות',
      content: <AttachedDocuments grave={grave} />,
      disabled: permission === 0 ? false : !myPermissionsAttachedDocuments.includes(permission)
    }, // ניתן להוסיף עוד טאבים כאן
    {
      label: 'הסטורית התנהלות',
      content: <TabContentColumnsHistory grave={grave} />,
      disabled: permission === 0 ? false : !myPermissionsAttachedDocuments.includes(permission)
    } // ניתן להוסיף עוד טאבים כאן
  ];

  useEffect(() => {
    fetchDataServer(['purchases', 'burials', 'customers'], token);
  }, []);

  const [refresh, setRefresh] = useState(0);

  const handleRefresh = () => {
    setRefresh((prev) => prev + 1); // שינוי ערך יגרום לרינדור מחדש
  };

  const [count, setCount] = useState(0);

  useEffect(() => {
    console.log('הקומפוננטה רונדרה מחדש!');
  }, [count]); // רינדור יתרחש כש count משתנה


  if (loading) return <LoadingOverlay />;

  return (
    <>
      <CardContent>
        {/* {JSON.stringify(context?.contextPurchases?.find((p) => p.graveId === grave?.unicId))} */}
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item xs>
            <Typography variant="h6" component="div" style={{ display: 'flex', justifyContent: 'space-between', textAlign: 'right' }}>
              <div>{`קבר : ${grave?.graveNameHe}`}</div>
              <div>
                <span style={{ fontWeight: 'bold' }}>{`סטטוס : `}</span>
                <span>{`${grave?.graveStatus}`}</span>
                <div>
                  <span style={{ fontWeight: 'bold' }}>{`סוג חלקה : `}</span>
                  <span>{`${grave?.plotType}`}</span>
                </div>
              </div>
            </Typography>
          </Grid>
        </Grid>

        <Grid container justifyContent="space-between">
          <ManagementPortfolio tabs={tabsData} />
        </Grid>
        {/* <div>
          <p>רענון מספר: {refresh}</p>
          <button onClick={handleRefresh}>רענן</button>
        </div>
        <div>
          <p>הערך הנוכחי: {count}</p>
          <button onClick={() => setCount(count + 1)}>הגדל</button>
        </div>
        <div>
      <button onClick={() => setRefreshKey(prev => prev + 1)}>טען מחדש</button>
    </div> */}
      </CardContent>
    </>
  );
}

export default GraveDetail;
